// import '../services/window';
import Ws from '@adonisjs/websocket-client';
import {WSURL} from '~/config/uri';
import Storage from '~/providers/Storage';
const TAG_LOG = '↔️ Socket';

let isConnected = false;
const ws = Ws(WSURL);

const connect = async () => {
  const token = await Storage.getItem(Storage.tokenKey);

  if (isConnected) {
    console.log(TAG_LOG, 'Já está conectado');
    return null;
  }

  ws.on('close', () => {
    console.log(TAG_LOG, 'Conexão fechado');
    isConnected = false;
  });

  ws.on('open', () => {
    console.log(TAG_LOG, 'Conexão aberta');
    isConnected = true;
  });

  return ws.withJwtToken(token).connect();
};

const onConnect = async (callback) => {
  ws.subscriptionOrSubscribe = (topic) => {
    let subscription = ws.getSubscription(topic);
    if (!subscription) {
      subscription = ws.subscribe(topic);
    }

    subscription.on('error', (e) => {
      console.log(TAG_LOG, `Erro na subscription ${topic}`, e);
    });

    return subscription;
  };

  if (isConnected) {
    callback(ws, true);
  }

  ws.on('open', () => callback(ws, false));
};

const close = async () => {
  try {
    ws.close();
  } catch (e) {
    console.log(TAG_LOG, 'Erro ao fazer o close', e.message);
  }
};

export default {
  connect,
  onConnect,
  close,
};
